import { render } from "./outlets-page.vue?vue&type=template&id=55639b2b&scoped=true"
import script from "./outlets-page.vue?vue&type=script&lang=js"
export * from "./outlets-page.vue?vue&type=script&lang=js"

import "./outlets-page.vue?vue&type=style&index=0&id=55639b2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55639b2b"]])

export default __exports__